import {Scenario} from "./model/scenario";
import config, {axiosConfig} from "../config";
import {default as axios} from "./axiosConfig";

export async function findScenario(scenarioCode: string) {
    const {data} = await axios.get<Scenario>(`${config.API_URL}/scenarios/${scenarioCode}`, axiosConfig);
    return data;
}